import React, { useEffect } from "react";
import { fetchCommunitySection } from "../../../../store/reducers/getWelcomeCommunitySlice";
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Footer from "../../Footer";
import Head from "../../Head";
import Spinner from "react-bootstrap/Spinner";

const GamesRules = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const dispatch = useDispatch();
  const { id } = useParams();

  const { loading, data, error } = useSelector((state) => state?.fetchCommunityById);

  useEffect(() => {
    if (id) {
      dispatch(fetchCommunitySection(id)); // Dispatch the action with the id
    }
  }, [dispatch, id]);

  // Handle loading and error states
  if (loading) {
    return (
      <div className="spinner-container">
        <Spinner animation="border" variant="dark" size="xl" />
      </div>
    );
  }
  const gamesRules = data;
  return (

    <><div className="top-head-section-new"></div>

      <div className="faq-section game-info-mainPage">
        <div className="container">
          <div className="aboutUs-header">
            <Head />
          </div>
          <h2 className="aboutUs-heading main-container-section game-ruleHeading">{gamesRules?.data?.heading}</h2>
          <div className="about-us">
            <h4> {gamesRules?.data?.title}</h4>
            <p>
              {gamesRules?.data?.description}
            </p>
            <br />
            <div className="demo-image">  <img src={`${process.env.REACT_APP_API_ENDPOINT_URL}/${gamesRules?.data?.image}`} alt="logo" /></div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 game-rules-disclosure">
              <div className="lend-cont-inner-in ">
                <p>
                  <strong>Disclosure:</strong> LF Coin ($LAL) is a community-driven meme coin created to celebrate sports fandom and foster community engagement. LF Coin is not affiliated with the Los Angeles Lakers, the National Basketball Association (NBA), or any associated organizations. The project operates independently and is solely focused on building a decentralized community of sports enthusiasts. As a meme coin, LF Coin carries no intrinsic value and should not be considered an investment or security.
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div className="about-footer">
        <Footer />
      </div>
    </>
  );
}

export default GamesRules;